// The Cupola with no hands: getting into it from wherever the viewer is, and
// a slow drift of the head round its side windows. Shared by the Cupola
// stream (src/stream/cupolastream.js) and the screensaver's Cupola show
// (src/screensaver/issshow.js). Both read the handles isstrack.js and
// cupola.js put on window.

// The head's drift: degrees and seconds. The side windows sit 30 degrees
// either side of yaw 0, which faces the velocity, and every 60 degrees round
// from there (cupola.js SIDE_AZIMUTHS), with the struts half way between. The
// two forward ones are behind the robotics workstation's monitors in NASA's
// model, so the head rests on the other four and turns to the next, back and
// forth across the back of the Cupola (unwrapped, so every turn is 60
// degrees). While resting it sways a few degrees. The pitch keeps the limb in
// the top third of a 16:9 frame (it is about 20 degrees under the horizontal
// from 420 km).
const WINDOWS = [90, 150, 210, 270, 210, 150];
const REST_S = 150, TURN_S = 30, SWAY = 6, SWAY_PERIOD = 80;
const PITCH_MID = -36, PITCH_SWING = 7, PITCH_PERIOD = 410;

// One step towards the Cupola: the ISS tracked on the real clock, then
// inside. Call it again (once a second is plenty) until the Cupola's phase
// is 'inside'.
export function stepIntoCupola(track = window.__issTrack, cupola = window.__cupola) {
  if (!track || !cupola) return;
  if (cupola.active) return;
  if (!track.found) return;
  if (!track.selected) { if (!track.animating) track.track(); return; }
  if (!track.animating) cupola.enter();
}

// Where the head looks t seconds into the drift: yaw and pitch in degrees,
// for window.__cupola.look.
export function cupolaHeadLook(t) {
  const step = Math.floor(t / (REST_S + TURN_S));
  const into = t - step * (REST_S + TURN_S);
  const from = WINDOWS[step % WINDOWS.length], to = WINDOWS[(step + 1) % WINDOWS.length];
  const turn = into < REST_S ? 0 : 0.5 - 0.5 * Math.cos((Math.PI * (into - REST_S)) / TURN_S);
  return {
    yaw: from + (to - from) * turn + SWAY * Math.sin((2 * Math.PI * t) / SWAY_PERIOD),
    pitch: PITCH_MID + PITCH_SWING * Math.sin((2 * Math.PI * t) / PITCH_PERIOD + 1.1),
  };
}
